<template>
    <div>
        <b-row>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label>Fornecedor</label>
                    <model-list-select
                        :list="fornecedores"
                        option-text="nome"
                        option-value="codFornecedor"
                        v-model="fornecedor"
                    >
                    </model-list-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label>Nome do Contrato</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="objeto"
                            max="40"
                            size="md"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Processo do Cliente</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="processoCliente"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Código do Contrato</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="contrato"
                            v-mask="'##.####'"
                            max="7"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <!-- <b-col sm="12" md="4">
                <b-form-group>
                    <label>Solicitante</label>
                    <model-list-select
                        :list="solicitantes"
                        option-text="nome"
                        option-value="codFuncionario"
                        v-model="solicitante"
                    >
                    </model-list-select>
                </b-form-group>
            </b-col> -->
        </b-row>
        <b-row>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Data Vigência (DE)</label>
                    <date-picker
                        v-model="dataInicioVigencia"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col> 
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Data Vigência (ATÉ)</label>
                    <date-picker
                        v-model="dataFimVigencia"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Natureza do Contrato</label>
                    <model-list-select
                        :list="naturezasContrato"
                        v-model="naturezaContrato"
                        option-text="descricao"
                        option-value="codigo"
                    ></model-list-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <b-checkbox v-model="apenasAtivos" class="mt-4 pt-2"
                        >Apenas Contratos Ativos</b-checkbox
                    >
                </b-form-group>
            </b-col>
            <!-- <b-col sm="12" md="4">
                <b-form-group>
                    <label>Situação</label>
                    <model-list-select
                        :list="situacoes"
                        option-text="descrSituacao"
                        option-value="codSituacao"
                        v-model="situacao"
                    >
                    </model-list-select>
                </b-form-group>
            </b-col>  -->
            <b-col class="mt-4">
                <b-button variant="primary" @click="pesquisar()"
                    >Pesquisar</b-button
                >
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import ContratosServicos from './ContratosServicos'

export default {
    data() {
        return {
            apenasAtivos: true,
            processo: null,
            contrato: null,
            processoCliente: null,
            objeto: null,
            fornecedores: [],
            fornecedor: null,
            solicitantes: [],
            solicitante: null,
            dataInicioVigencia: null,
            dataFimVigencia: null,
            situacoes: [],
            situacao: null,
            naturezasContrato: [
                {
                    codigo: '0',
                    descricao: "Venda"
                },
                {
                    codigo: '1',
                    descricao: "Compra"
                },
                // {
                    // codigo: '2',
                    // descricao: "Ambos"
                // }
            ],
            naturezaContrato: null
        }
    },

    components: {
        ModelListSelect
    },

    methods: {
        obterOpcoesFiltros() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterOpcoesFiltros().then((response) => {
                if (response) {
                    if (response.success) {
                        this.fornecedores = response.data.fornecedores
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        pesquisar() {
            let filtroDto = {
                apenasAtivos: this.apenasAtivos,
                contrato: this.contrato,
                processoCliente: this.processoCliente,
                fornecedor: this.fornecedor,
                objeto: this.objeto,
                // solicitante: this.solicitante,
                dataInicioVigencia: this.dataInicioVigencia
                    ? this.$moment(this.dataInicioVigencia, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                dataFimVigencia: this.dataFimVigencia
                    ? this.$moment(this.dataFimVigencia, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                natureza: this.naturezaContrato
                // situacao: this.situacao
            }
            this.$emit('pesquisar', filtroDto)
        }
    },

    mounted() {
        this.obterOpcoesFiltros()
    },

    watch: {
    }
}
</script>